module.exports = __webpack_public_path__ + "img/r-maarten-van-den-heuvel-400626-unsplash-min-460x295.a810a49e.jpg";